module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/osbornebulls.e320a3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/osbornebulls.jpg
// module id = ylvP
// module chunks = 0